/**
 * Placeholder for menu items whose backend is not yet implemented.
 * Used by Phase 2/3/4 pages so the sidebar is fully wired and the menu
 * navigates correctly, while keeping the actual implementation a clearly
 * scoped follow-up. Each instance lists what's planned so the operator
 * (and code reviewer) sees the design without needing to dig into the plan
 * doc.
 */

interface ComingSoonProps {
  title: string;
  phase: 'Phase 2' | 'Phase 3' | 'Phase 4';
  summary: string;
  bullets: string[];
}

export function ComingSoon({ title, phase, summary, bullets }: ComingSoonProps) {
  return (
    <div data-testid={`coming-soon-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex items-center gap-3">
        <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
        <span className="inline-flex items-center rounded-full border border-amber-200 bg-amber-50 px-2.5 py-0.5 text-xs font-medium text-amber-700">
          {phase} — coming next
        </span>
      </div>
      <p className="mt-2 max-w-2xl text-sm text-gray-600">{summary}</p>

      <div className="mt-6 rounded-lg border border-dashed border-gray-300 bg-white p-6">
        <h3 className="text-sm font-medium text-gray-700">What this page will show</h3>
        <ul className="mt-3 list-disc space-y-1.5 pl-5 text-sm text-gray-600">
          {bullets.map((b) => (
            <li key={b}>{b}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
